module.exports = __webpack_public_path__ + "static/media/rain_img.4df0a817.png";